
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { getPythPrice } from '../../lib/solana/pyth';

export const pythApi = {
    /**
     * Get latest price for a symbol
     */
    getPrice: async (symbol: string) => {
        return await getPythPrice(symbol);
    },

    /**
     * Get price history (Mock implementation as Pyth Benchmarks is separate)
     */
    getPriceHistory: async (symbol: string, resolution: '1h' | '1d') => {
        const now = Math.floor(Date.now() / 1000);
        const count = 24;
        const interval = resolution === '1h' ? 3600 : 86400;
        
        return Array.from({ length: count }).map((_, i) => ({
            time: now - (i * interval),
            price: 100 + Math.random() * 10
        })).reverse();
    }
};
